import { RootState } from "src/redux/store";
import { useSelector } from "react-redux";
import { CurrentSystemResourceAccesses } from "src/pages/information-assets/models/information-asset-accesses";
export function useFetchInformationAssetAccesses(): CurrentSystemResourceAccesses {
  const currentAccessesForSystemResources: CurrentSystemResourceAccesses = useSelector(
    (rootState: RootState) => rootState.informationAssetsAccesses.informationAssetsAccessesPEV.value
  );

  return new CurrentSystemResourceAccesses(currentAccessesForSystemResources?.currentAccesses??[]);
}
